import { v4 as uuidv4 } from 'uuid';
import { getCancellationServiceApiUrl } from '../selectors/selectors';
import { APPLICATION_JSON, CLIENT_ID } from '../constants/constants';

export default {
  fetch: ({
    body,
    channel,
    envConfig,
    locale,
    correlationId,
  }, action, state) => ({
    url: `${getCancellationServiceApiUrl(state)}/flight/schedule/record_action`,
    opts: {
      method: 'POST',
      timeout: 30e3,
      credentials: 'include',
      headers: {
        Accept: APPLICATION_JSON,
        'Content-Type': APPLICATION_JSON,
        'x-client-id': CLIENT_ID,
        'x-correlation-id': correlationId || uuidv4(),
        'x-locale': locale,
        'x-user-agent': window.navigator.userAgent,
        'x-channel': channel,
        'x-timestamp': new Date().toISOString(),
        'x-tulips-env': envConfig?.['x-tulips-env'],
      },
      body,
    },
  }),
};
